/* -------------------------- Design imports start -------------------------- */
import React from 'react'

import Page from '../../components/layout/Page'
import RequestForm from '../../components/widgets/RequestForm'
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */
/* ------------------------- Functional imports end ------------------------- */

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function UnauthRequestPage() {
  /* -------------------------------------------------------------------------- */
  /*                              Render Component                              */
  /* -------------------------------------------------------------------------- */
  return (
    <Page>
      <RequestForm />
    </Page>
  )
}
